app.factory('authInterceptor',
['$rootScope', '$q', '$window','$injector','$cookies','cfpLoadingBar',
function($rootScope, $q, $window, $injector,$cookies , cfpLoadingBar) {
    return {
        request: function(config){
            // if ($window.sessionStorage.getItem('token')) {
            //     config.headers['x-stonehenge-token'] = $window.sessionStorage.getItem('token');
            // }
            if ($cookies.get('token')) {
                config.headers['x-stonehenge-token'] = $cookies.get('token');
            }

            return config;
        },
        response: function(response){
            cfpLoadingBar.complete()
            return response;
        },
        responseError : function(rejection) {
            cfpLoadingBar.complete()
            let authError = rejection.status === 403 || rejection.status === 401 || $rootScope.ON_LOGIN === true;
            let ignoreAuth = rejection.config.ignoreAuth === true;

            if (authError && !ignoreAuth){
                if(rejection.status === 401){
                    let message = rejection.data.message || "Sorry, error validating user"
                    $rootScope.$broadcast("event:loginRequired", {error: message});
                }
                if(rejection.status === 403){
                    alert.error(rejection.data.message)
                }
                var deferred = $q.defer();
                return deferred.promise;
            }
            return $q.reject(rejection);
        }
    }
}])


app.config(['$httpProvider', '$routeProvider', function ($httpProvider, $routeProvider) {
    $httpProvider.interceptors.push('authInterceptor')
}]);
